type SubscriptionRequiredModal = {
  messageKey: string | undefined;
  productType: SubscriptionProductType | undefined;
  show: boolean;
};
export const useSubscriptionRequiredModal = () =>
  useState<SubscriptionRequiredModal>('subscriptionRequiredModal', (): SubscriptionRequiredModal => {
    return {
      messageKey: undefined,
      productType: undefined,
      show: false,
    };
  });
